module.exports = __webpack_public_path__ + "media/assets/icons/wishlist-1259e870c29df7c659e07d0c1c50c68c.png";